import { Button, PageHeader } from '@flos/react-ui';
import { useRecoilValue, useResetRecoilState } from 'recoil';
import { useHippoText } from '../../hooks/useHippoText';
import type { WizardPageComponent } from '../../config/wizardPagesConfig';
import useWizardNavigation from '../../hooks/useWizardNavigation';
import { businessFlowSelector } from '../../recoil/selectors/getBusinessFlowSelector';
import { onsaProgressSelector } from '../../recoil/selectors/onsaProgressSelector';

const EmptyShoppingBasketPage: WizardPageComponent = () => {
    const { wizardGotoStep } = useWizardNavigation();
    const getHippoText = useHippoText();
    const businessFlow = useRecoilValue(businessFlowSelector);
    const resetOnsaProgress = useResetRecoilState(onsaProgressSelector);

    return (
        <>
            <PageHeader title={getHippoText('DSS-SHOPPING-BASKET-TITLE')} align="center" />
            <div className="u-spacing-inset-xxl u-flex-box u-flex-box--col u-flex-box--center u-text-center">
                <img
                    id="emptyBasket"
                    alt=""
                    // eslint-disable-next-line max-len
                    src="https://flos.topdanmark.cloud/development/static/media/streamlinehq-zero-purchase-2-400-ico_FUJuuvkmowZ1ZaFi.70598106.png"
                />
                <p className="h4 u-color-secondary-4-medium u-spacing-stack-none">
                    {getHippoText('DSS-SHOPPING-BASKET-OVERLAY-EMPTY-BASKET-LABEL')}
                </p>
                {businessFlow === 'ONSA' && (
                    <Button
                        onClick={() => {
                            wizardGotoStep('ProductSelectorPage');
                            resetOnsaProgress();
                        }}
                    >
                        {getHippoText('DSS-SHOPPING-BASKET-OVERLAY-EMPTY-BASKET-CONTINUE')}
                    </Button>
                )}
            </div>
        </>
    );
};

export default EmptyShoppingBasketPage;
